const validatePhoneNumber = (phone) => {
  let onlyNumbers = phone.replace(/\D/g, ""); // Remove non-numeric characters
  return onlyNumbers.length <= 10 ? onlyNumbers : onlyNumbers.slice(0, 10);
};

export { validatePhoneNumber };
